import 'slick-carousel';

const $sliderCover = $('.js-slick-slider-cover');
const $statusSliderCover = $('.js-slick-slider-cover-counter');
const $firstSlider = $sliderCover.find('.slider-item')[0];

$sliderCover.on('init reInit afterChange', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $statusSliderCover.text(i + '/' + slick.slideCount);
});

$sliderCover.on('init', () => {
    // console.log('init');
    $($firstSlider).find('.slider-item-inner').Lazy({ attribute: 'data-bg' });
});

$sliderCover.slick({
    centerPadding: '0',
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    prevArrow: $('.js-prev-slide-in-slider-cover'),
    nextArrow: $('.js-next-slide-in-slider-cover')
});

$sliderCover.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    // console.log('beforeChange');
    $sliderCover.find(`div[data-slick-index="${nextSlide}"]`).find('.slider-item-inner').Lazy({ attribute: 'data-bg' });
});
